import React, { useEffect, useState } from "react";
import styles from "../Pickup/style.module.css";
import Header from "../../partials/ExternalHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { displayLockerNumber } from "../../../utils/displayLockerNumber";
import { notification, Spin } from "antd";
import back from "../../../images/back-white.png";

const LockerPinOpen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const url = process.env.REACT_APP_APP_BACK_URL;
  const { id, slug } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isNotFound, setIsNotFound] = useState(false);
  const [lockerBusy, setLockerBusy] = useState(false);
  const [opened, setOpened] = useState(!!location.state?.opened);
  const [locker, setLocker] = useState(null);
  const lockerNumber =
    locker?.display_number || displayLockerNumber(locker?.number);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await fetch(`${url}/api/lockers/${id}`);
        const json = await response.json();
        const row = json?.locker;
        const sameSite =
          String(row?.site_slug || "").toLowerCase() ===
          String(slug || "").toLowerCase();
        if (!json.success || !row || !sameSite) {
          setIsNotFound(true);
          return;
        }
        setLocker(row);
      } catch (error) {
        setIsNotFound(true);
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, [id, slug, url]);

  useEffect(() => {
    if (location.state?.attempted && !location.state?.opened) {
      notification.error({
        message: "Unable to open locker",
        description:
          "The code matched, but the locker did not open. Tap Open Locker to try again.",
        duration: 6,
      });
    }
  }, [location.state]);

  const handleOpen = async () => {
    setLockerBusy(true);
    try {
      const response = await fetch(`${url}/api/lockers/relay/state/update`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, state: "2" }),
      });
      const json = await response.json();
      if (json.success) {
        setOpened(true);
        notification.success({
          message: "Success",
          description: json.message || "Locker opened successfully",
          duration: 4,
        });
      } else {
        notification.error({
          message: "Unable to open locker",
          description:
            json.message ||
            json.error ||
            "We could not open the locker. Please try again.",
          duration: 6,
        });
      }
    } catch (error) {
      notification.error({
        message: "Unable to open locker",
        description:
          "We could not reach the locker. Please check your connection and try again.",
        duration: 6,
      });
    } finally {
      setLockerBusy(false);
    }
  };

  return (
    <div className={styles.heading}>
      <div className="body-wrap">
        <div className="container-fluid px-0">
          <Header />
          <div className={styles.body_wrap}>
            <div className={`login-container ${styles.externalPickupLogin}`}>
              <div className="row justify-content-center w-100 mx-0">
                <div className="col-12 px-2 px-sm-3">
                  {isLoading ? (
                    <div
                      className={`form-box card-box ${styles.externalOrderCard}`}
                      style={{ padding: 0 }}
                    >
                      <div className={styles.externalPageLoader}>
                        <Spin size="large" tip="Loading locker…" />
                      </div>
                    </div>
                  ) : isNotFound ? (
                    <div className={styles.externalNotFound}>
                      <div className={styles.externalNotFoundTitle}>
                        Locker not available
                      </div>
                      <p className={styles.externalNotFoundText}>
                        This locker code is not valid for this location.
                      </p>
                    </div>
                  ) : (
                    <div
                      className={`form-box card-box ${styles.externalOrderCard}${
                        opened ? ` ${styles.externalOrderCardOpened}` : ""
                      }`}
                      style={{ padding: 0 }}
                    >
                      <div className={styles.externalOrderHeader}>
                        <div className={styles.externalOrderBackWrap}>
                          <button
                            type="button"
                            className={styles.externalOrderBackBtn}
                            aria-label="Go back"
                            onClick={() => navigate(`/${slug}/pin`)}
                          >
                            <img width={20} height={20} src={back} alt="" />
                          </button>
                        </div>
                        <div className={styles.externalOrderHeaderCenter}>
                          <span className={styles.pickup_label2}>Locker</span>
                          <div className={styles.externalOrderCode}>
                            #{lockerNumber}
                          </div>
                        </div>
                        <div
                          className={styles.externalOrderHeaderSpacer}
                          aria-hidden="true"
                        />
                      </div>
                      <Spin
                        className={styles.externalOrderSpin}
                        spinning={lockerBusy}
                        tip={lockerBusy ? "Opening locker…" : undefined}
                        size="large"
                      >
                        <div className={styles.externalOrderBody}>
                          <p className={styles.externalOrderMessage}>
                            {opened
                              ? `Locker #${lockerNumber} is open`
                              : `Locker #${lockerNumber}`}
                          </p>
                          {locker?.department_name ? (
                            <p className={styles.externalOrderMessageMuted}>
                              {locker.department_name}
                            </p>
                          ) : null}
                          <p className={styles.externalOrderMessageMuted}>
                            {opened
                              ? "You can open it again if needed."
                              : "Tap Open Locker when you are at the locker."}
                          </p>
                          <div className={styles.externalOrderActions}>
                            <button
                              type="button"
                              className={`${styles.externalOrderBtn} ${styles.externalOrderBtnPrimary}`}
                              disabled={lockerBusy}
                              onClick={handleOpen}
                            >
                              {opened ? "Re-open Locker" : "Open Locker"}
                            </button>
                          </div>
                        </div>
                      </Spin>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LockerPinOpen;
